import CarouselCard from "./Card";
import Carousel from "./Carousel";

const CardsCarousel = Object.assign(Carousel, { Card: CarouselCard });

export default CardsCarousel;
